import { render } from "./TokenTab.vue?vue&type=template&id=650531bd"
import script from "./TokenTab.vue?vue&type=script&lang=js"
export * from "./TokenTab.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__